import React from 'react'
import styles from './Legend.module.css'

export const Legend = ({ data }) => {
  const proportions = data.map(({ cells, totalAnswers }) => totalAnswers / cells.length)
  const highest = Math.ceil(Math.max(...proportions))
  return <div className={styles.legend}>1 tile = {highest} responses</div>
}
